import React from 'react'
import PropTypes from 'prop-types'
import BuildingPreviewWithFav from 'Components/BuildingPreviewWithFav'
import SvgIcon from 'Components/SvgIcon'
import {
  _BuildingList,
  buildingTitleCss,
  _Deleting,
  _BuildingCheckBox,
} from './styles'

const BuildingList = ({
  buildingList,
  deleteBuildingIds,
  onDelete,
  showLimit = 999,
  sourcePage,
}) => {
  if(!buildingList) return null
  return Object.keys(buildingList).map((buildingId, index) => {
    if(
      !buildingList[buildingId] ||
      index >= showLimit
    ) {
      return null
    }
    const building = buildingList[buildingId]
    const deleting = (deleteBuildingIds && deleteBuildingIds[buildingId])
    return (
      <_BuildingList key={building.title}>
        <BuildingPreviewWithFav
          data-test-id="buildingPreview"
          userIsAuthentificated
          preConPreview
          hideFavBtn
          building={building}
          customTitleCss={buildingTitleCss}
          sourcePage={sourcePage}
        />
        <_BuildingCheckBox
          data-test-id="buildingListCheckbox"
          onClick={() => onDelete(building, index)}
        >
          <SvgIcon
            name={'#icon-close'}
            width={12}
            height={12}
          />
        </_BuildingCheckBox>
        {
          deleting && (
            <_Deleting data-test-id="deletingIndicator" />
          )
        }
      </_BuildingList>
    )
  })
}
BuildingList.propTypes = {
  buildingList: PropTypes.shape({}),
  deleteBuildingIds: PropTypes.shape({}),
  onDelete: PropTypes.func,
  showLimit: PropTypes.number,
  sourcePage: PropTypes.string,
}
export default BuildingList
